<template>
  <div class="analysis">
    <div class="top wbg" v-if='$common.AUTH("statis:loan:lists")'>
      <a-row class="row" :gutter="40">
        <a-col :span='6' class="flex">
          <label>委托类型：</label>
          <a-select placeholder="请选择" class="select">
            <a-select-option :value="1">委托代理</a-select-option>
            <a-select-option :value="2">委托管理</a-select-option>
          </a-select>
        </a-col>
        <a-col :span="6" class="flex">
          <label>案件类型：</label>
          <a-select v-model="form.cause_type" placeholder="请选择"  class="select" allowClear>
            <!-- <a-select-option :value="0" disabled>调解</a-select-option> -->
            <a-select-option :value="2">调解</a-select-option>
            <a-select-option :value="1">诉讼</a-select-option>
            <a-select-option :value="3" disabled>公证执行</a-select-option>
          </a-select>
        </a-col>
        <a-col :span="6" class="flex">
          <label>原告：</label>
          <a-select v-model="form.accuser_id" placeholder="请选择" mode="multiple" :maxTagCount='1' :maxTagTextLength='12' allowClear  class="select" :filter-option="$common.filterOption">
            <a-select-option v-for="item in accuserList" :key="item.title" :value="item.id">{{ item.title }}</a-select-option>
          </a-select>
        </a-col>
        <a-col :span="6" class="flex">
          <label>管辖法院：</label>
          <a-select v-model="form.court_id" placeholder="请选择" mode="multiple" :maxTagCount='1' :maxTagTextLength='14' @search="handleSearch" :default-active-first-option="false" :show-arrow="false" :filter-option="false" :not-found-content="null"  class="select"
            allowClear>
            <a-select-option v-for="item in courtList" :key="item.title" :value="item.id">{{ item.title }}</a-select-option>
          </a-select>
        </a-col>
      </a-row>
      <a-row class="row" :gutter="40">
         <!-- <a-col :span="4" class="flex" style="padding-right: 0;">
             <a-radio-group v-model="type">
              <a-radio :value="1" >回款日期</a-radio>
              <a-radio :value="2" >分期日期</a-radio>
            </a-radio-group>
        </a-col> -->
          <a-col :span="6" class="flex">
            <label>回款录入日期：</label>
            <timePick @PickTime="PickTime" ref="timePicker"></timePick>
          </a-col>
          <a-col :span="6" class="flex">
          <a-button icon="search" type='primary' style="height:32px;" @click="search">查询</a-button>
          <a-button style="height:32px;margin-left:20px" @click="reset">重置</a-button>
          <a-button icon="upload" type='primary' ghost style="height:32px;margin-left:20px;" @click="out(2)"  v-if='$common.AUTH("export:hkxxb")'>导出</a-button>
          </a-col>
        </a-row>
    </div>
    <div class="conmains">
      <div class="h2">案件回款统计</div>
      <div class="con">
        <!-- <div class="li"><div class="tit">待还款总额(元)</div><div class="p">{{ static.sum  | showYuan}}</div></div> -->
        <div class="li"><div class="tit">当前回款总额(元)</div><div class="p">{{ allMoney(static.fee_list,[8,4,5,9]) | showYuan}}</div></div>
        <div class="li"><div class="tit">本金回款总额(元)</div><div class="p">{{ moneyKey(static.fee_list,8) | showYuan}}</div></div>
        <div class="li"><div class="tit">律师费回款总额(元)</div><div class="p">{{ moneyKey(static.fee_list,4) | showYuan }}</div></div>
        <div class="li"><div class="tit">差旅费回款总额(元)</div><div class="p">{{ moneyKey(static.fee_list,5) | showYuan}}</div></div>
        <div class="li"><div class="tit">利息回款总额(元)</div><div class="p">{{ moneyKey(static.fee_list,9) | showYuan}}</div></div>
        <div class="li"><div class="tit">银行结清总额(元)</div><div class="p">{{ moneyKey(static.fee_list,11) | showYuan}}</div></div>
        <div class="li"><div class="tit">本金回款比例</div><div class="p">{{static.payee_percent}}%</div></div>
      </div>
    </div>
    <div class="botmains">
      <div class="tableList" v-if='$common.AUTH("statis:loan:lists")'>
        <div class="table">
          <table>
            <thead>
              <td width='40'>序号</td>
              <td width='72'>债务人</td>
              <td width='130'>债务人证件号码</td>
              <td width='80'>所属案件</td>
              <td width='100'>当前进度</td>
              <td width="120">当期回款</td>
              <td width="120">总还款金额</td>
              <td width='100'>未还款金额</td>
              <td width='140'>已确认债权金额</td>
              <td width='100'>分期总额</td>
              <td width='108'>案件录入日期</td>
            </thead>
            <tbody>
              <tr v-for='(i,index) in data' :key='index'>
                <td>{{ (formPage.page-1)*10+index+1 }}</td>
                <td><span  class="curpoter" @click='dbclick(i)'> {{i.debtor.realname}}</span></td>
                <td>{{i.debtor.chinaid}}</td>
                <td> 案件 {{ i.sort }} </td>
                <td>
                  <span v-if="i.step && i.step.length">{{ i.step[0].title }}</span>
                  <span v-else>/</span>  
                </td>
                <td>{{ i.payee_sum | showYuan}}</td>
                <td>{{ i.payee_total_sum | showYuan}}</td>
                <td>{{(i.credit_sum-i.payee_total_sum) | showYuan}}</td>
                <td>{{ i.credit_sum | showYuan}}</td>
                <td>{{i.loan_sum | showYuan}}</td>
                <td>{{ i.create_time | yearFormat }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="pages">
          <a-pagination v-model="formPage.page" show-quick-jumper :total="total" show-less-items :pageSize='10'  @change='turnpage' :show-total="(total) => `小计：${total} `" />
        </div>
      </div>
      <div class="nqx" v-else>您没有该页面的访问权限，请联系管理员开通。</div>
    </div>
  </div>
</template>
<script>
  import {getAccuserAll} from '@/server/api'
  import {getDirectory } from "@/server/directory"
  import {statisPayee,payeeList } from '@/server/debtor'
  import { exportForm } from '@/assets/js/unit'
  export default {
    data() {
      return {
        static: {
          sum: 0,
          fee_list: [],
          payee_percent: 0
        },
        times: {},
        type: 1,
        courtList: [], //法院
        accuserList: [],
        form: {
          accuser_id: [],
          cause_type: undefined,
        },
        formPage: {
          page: 1,
          limit: 10
        },
        data: [],
        total: 0
      }
    },
    created() {
      getAccuserAll().then((res) => {
        this.accuserList = res.list
      })
      this.search()
    },
    methods: {
      dbclick(record) {
        if (this.$common.AUTH('debtor:info')) {
          let routeUrl = this.$router.resolve({
            "name": "lydetails",
            params: {
              "id": record.debtor.id
            }
          });
          window.open(routeUrl.href, '_blank');
        } else {
          this.$message.error({
            content: '暂无权限',
            key: 'updatable'
          });
        }
      },
      allMoney(data,key){
        if(data.length>0){
          return data.filter(ele=>{return key.indexOf(ele.type)>=0}).reduce((prev,next)=>{return prev+next.fee_sum*1},0)
        }
        else return 0
      },
      moneyKey(data, key) {
        const sumsData = data.find(ele => { 
          return ele.type == key
        })
        return sumsData ? sumsData.fee_sum : '-'
      },
      getList() {
        const form = JSON.parse(JSON.stringify(this.form))
        form.stime=this.type==2?'':this.times.stime
        form.etime=this.type==2?'':this.times.etime
        form.accuser_id = form.accuser_id.toString()
        payeeList(Object.assign(form, this.formPage)).then(e => {
          this.data = e.list;
          this.total = e.count
        })
      },
      search() {
        let form = JSON.parse(JSON.stringify(this.form))
        if (this.type == 1) {
          form.stime = this.times.stime
          form.etime = this.times.etime
        } else {
          form.loan_period_stime = this.times.stime
          form.loan_period_etime = this.times.etime
        }
        form.accuser_id = form.accuser_id.toString()
        statisPayee(form, this.type).then(e => {
          this.static = {
            sum: this.type == 1 ? '-' : (e.sum == 0 ? '-' : e.sum),
            fee_list: this.type == 1 ? e.fee_list : [],
            payee_percent: this.type == 1 ? (((e.payee_percent.up || 0) / (e.payee_percent.down || 1)) * 100).toFixed(1) : 0
          }
        })
        this.formPage.page = 1;
        this.getList()
      },
      reset(){
        this.form.limit = 10
        this.form.page = 1
        this.form.cause_type = undefined
        this.form.accuser_id = []
        this.form.court_id = []
        this.form.loan_period_stime = ''
        this.form.loan_period_etime = ''
        this.$refs.timePicker.clearTime()
        this.search()
      },
      out(type) {
        let form = JSON.parse(JSON.stringify(this.form))
        if (this.type == 1) {
          form.stime = this.times.stime
          form.etime = this.times.etime
        } else {
          form.loan_period_stime = this.times.stime
          form.loan_period_etime = this.times.etime
        }
        form.accuser_id = form.accuser_id.toString()
        exportForm(type,form)   
      },
      turnpage(val) {
        this.formPage.page = val;
        this.getList()
      },
      PickTime(e) {
        if ("stime" in e) {
          this.times.stime = e.stime
        } else {
          this.times.etime = e.etime
        }
      },
      handleSearch(val) {
        getDirectory({
          limit: 100,
          title: val
        }).then((res) => {
          this.courtList = res.list
        })
      },
    }
  }
</script>
<style lang="less" scoped>
  .contbox {
    display: flex;
    width: 510px;
    box-sizing: border-box;
    background: #ffffff;
    flex-wrap: wrap;
    p {
      font-size: 14px;
      margin-bottom: 0;
      line-height: 30px;
      margin-right: 20px;
    }
  }
  @import url('@/assets/css/search.less');
  .h2 {
    line-height: 62px;
    padding-left: 20px;
    font-size: 16px;
    color: #0e2949;
    font-weight: bold;
    border-bottom: 1px solid #efefef;
  }
  .wbg {
    margin-bottom: 10px;
  }
  .conmains {
    background: #fff;
    .con {
      height: 105px;
      display: flex;
      background: #F6F8FC;
      margin: 20px 20px 0;
      .li {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 15%;
        flex-direction: column;
        &:nth-last-child(1) {
          width: 10%;
        }
        .tit {
          font-size: 14px;
          font-weight: 500;
          color: #0E2949;
          line-height: 20px;
        }
        .p {
          font-size: 14px;
          font-weight: 500;
          margin-top: 5px;
          color: #0E2949;
          line-height: 20px;
        }
      }
    }
  }
  .botmains {
    background: #fff;
    .tableList {
      padding: 20px;
      .table {
        thead {
          td {
            padding-left: 0;
            &:nth-child(1) {
              padding-left: 20px;
            }
          }
        }
        tbody {
          tr:nth-last-child(1) {
            border-bottom: 1px solid #ebebeb;
          }
          td {
            padding: 6px 0;
            height: 60px;
            &:nth-child(1) {
              padding-left: 20px;
            }
            p {
              padding: 10px 0;
              margin: 0;
              border-bottom: 1px solid #ebebeb;
              &:nth-last-child(1) {
                border: 0 none;
              }
            }
          }
        }
      }
    }
  }
</style>